import { render, staticRenderFns } from "./proposal-list-fields.vue?vue&type=template&id=68e69cd6&scoped=true&lang=pug"
import script from "./proposal-list-fields.vue?vue&type=script&lang=js"
export * from "./proposal-list-fields.vue?vue&type=script&lang=js"
import style0 from "./proposal-list-fields.vue?vue&type=style&index=0&id=68e69cd6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e69cd6",
  null
  
)

export default component.exports